export const dropdownMenu = {
  menu: { optionPadding: '10px 8px' }
};

export const header = {
  colours: {
    main: { background: '#dbe3e9' },
    subtitle: { text: '#4e5c67' }
  },
  spacing: 10,
  subtitle: {
    borderRadius: '0px',
    borderWidth: '0px',
    padding: '6px'
  }
};

export const button = {
  borderRadius: '0px'
};



// WEBPACK FOOTER //
// ./themes/upf-theme/overrides.js